import axios from "axios";
import * as NOTIFICATION_SERVICE from "@/drc/services/notification-service"
import {RESPONSE_STATUS} from "@/common/utils/constants"
import Router from '@/common/router';
import {EventUnauthorizedUserPopup} from "@/common/configurations/event-bus.js";
import {sendEmail} from "@/common/services/common-request-service"
import store from "@/common/store";

/**
 * AXIOS interceptors
 *
 * Request interceptor
 */
axios.interceptors.request.use(
	function (config) {
		return config;
	},
	function (error) {
		return Promise.reject(error);
	}
);

let isNotificationForStoppedServerShown = false;
/**
 * Response interceptor
 */
axios.interceptors.response.use(
	function (response) {
		return response;
	},
	function (error) {
		const unauthorizedUserStatusCode = 401;
		let errorStatus = error.response.status;
		if (errorStatus == unauthorizedUserStatusCode) {
			let redirectPath = Router.currentRoute.fullPath ? Router.currentRoute.fullPath : Router.currentRoute.path
			console.warn(`Redirected after login to: ${redirectPath}`)
			if(!redirectPath.includes('/logout')){
				localStorage.setItem('redirectToUrlAfterLogin', redirectPath)
			}
			EventUnauthorizedUserPopup.$emit("start-unauthorized-user-popup");
			return Promise.reject(error);
		}

		if (!error.response.data.path.includes('/statistic')) {
			sendEmailToSystemAdministrators(error);
		}

		if (error.response === undefined && isNotificationForStoppedServerShown === false) {
			isNotificationForStoppedServerShown = true;
			NOTIFICATION_SERVICE.serverErrorHandlingNotification();
			return Promise.reject(error);
		}

		if(error.config.url?.includes?.("gop/main") ||
			error.response.data.message.includes('Such time off, already exists') ||
			(error.config.url.includes("login") || error.config.url.includes('auth')) && errorStatus === 404
		){
			return Promise.reject(error);
		}

		if(errorStatus === 404){
			Router.push('/404');
			return Promise.reject(error);
		}

		if ((!error.config?.url?.includes?.("login") && !error.config?.url?.includes?.("main/projects") && !RESPONSE_STATUS.skipErrors.includes(errorStatus) ||
			(!(error.config?.url?.includes?.("sso") && error.status === 400))) && (!error.config?.url?.includes?.("/statistics") && error.config?.method !== 'post')) {
			if (error.response.data.message !== 'Email already exist') {
				NOTIFICATION_SERVICE.serverErrorHandlingNotification();
			}
			return Promise.reject(error);
		}
		if (error.config?.url?.includes?.("/statistics") && error.config?.method === 'post') {
			console.error(error)
		}
		return Promise.reject(error);
	}
);

function sendEmailToSystemAdministrators(error) {
	if (process.env.NODE_ENV === "production" || process.env.NODE_ENV === "prod") {
		const user = store.getters.getUser;
		const emailData = {
			from: user?.email,
			to: {
				emails: ['petar.stoyanov@akkodis.com', 'desislava.aleksandrova@akkodis.com', 'vasil.ayvazov@akkodis.com',
					'plamen.velichkov@akkodis.com', 'sabiha.mangova@akkodis.com']
			},
			title: `DRC auto-error email notification`,
			message: `The user with id: ${user?.id} has an error when trying to reach the backend endpoint: ${error.config.url}.<br>
							The error status code is: ${error.response.status}.<br>
							The method type is: "${error.response.config.method?.toUpperCase()}".<br>
							The response message is: "${error.response.data.message}".<br>
							The frontend url is: ${window.location.href}<br>`,
			showSender: !!user
		}

		if (!window.location.href.includes('login')) {
			sendEmail(emailData)
				.then(() => console.warn("Email sent successfully to the system administrators."))
				.catch((error) => console.error(error));
		}
	}
}
